/**
 * Accordion — shared frontend behaviour.
 *
 * @package Vertaview
 */

/**
 * Initialise a single accordion instance.
 *
 * @param {HTMLElement} wrap Accordion wrapper element.
 */
export function initAccordion( wrap ) {
	if ( wrap.dataset.accordionInit === 'true' ) {
		return;
	}

	wrap.dataset.accordionInit = 'true';

	const allowMultiple = wrap.dataset.allowMultiple === 'true';

	const items = [ ...wrap.querySelectorAll( '.accordion__item' ) ];
	const triggers = [ ...wrap.querySelectorAll( '.accordion__trigger' ) ];

	if ( ! triggers.length ) {
		return;
	}

	function openItem( item ) {
		const btn = item.querySelector( '.accordion__trigger' );
		item.classList.add( 'is-open' );
		if ( btn ) {
			btn.setAttribute( 'aria-expanded', 'true' );
		}
	}

	function closeItem( item ) {
		const btn = item.querySelector( '.accordion__trigger' );
		item.classList.remove( 'is-open' );
		if ( btn ) {
			btn.setAttribute( 'aria-expanded', 'false' );
		}
	}

	function toggle( item ) {
		const isOpen = item.classList.contains( 'is-open' );

		if ( ! allowMultiple ) {
			items.forEach( ( other ) => {
				if ( other !== item ) {
					closeItem( other );
				}
			} );
		}

		if ( isOpen ) {
			closeItem( item );
		} else {
			openItem( item );
		}
	}

	triggers.forEach( ( trigger ) => {
		trigger.addEventListener( 'click', () => {
			const item = trigger.closest( '.accordion__item' );
			if ( item ) {
				toggle( item );
			}
		} );
	} );

	triggers.forEach( ( trigger, idx ) => {
		trigger.addEventListener( 'keydown', ( e ) => {
			let targetIdx = null;

			switch ( e.key ) {
				case 'ArrowDown':
					targetIdx = ( idx + 1 ) % triggers.length;
					break;
				case 'ArrowUp':
					targetIdx =
						( idx - 1 + triggers.length ) % triggers.length;
					break;
				case 'Home':
					targetIdx = 0;
					break;
				case 'End':
					targetIdx = triggers.length - 1;
					break;
				default:
					return;
			}

			if ( targetIdx !== null ) {
				e.preventDefault();
				triggers[ targetIdx ].focus();
			}
		} );
	} );
}

/**
 * Boot every accordion / FAQ block on the page.
 */
export function bootAccordions() {
	document
		.querySelectorAll(
			'.wp-block-vertaview-accordion, .wp-block-vertaview-faq'
		)
		.forEach( initAccordion );
}
